import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFCPAP from '@/components/UI/svg/river2/Icon/EFCPAP';
import EFTank from '@/components/UI/svg/river2/Icon/EFTank';
import EFWifi from '@/components/UI/svg/river2/Icon/EFWifi';
import EFHandyBg from '@/components/UI/svg/river2/Icon/EFHandyBg';
import EFCompare from '@/components/UI/svg/river2/Icon/EFCompare';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

// 视频是否已播放
let hasNoneEnterPlayFlag = true;
const { EFPic } = createEFPic('/media/river2/pc/');
const { EFPic: EFPic2 } = createEFPic('');
const ICON_ZA_1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
        <path
            d="M4.41695 24.5928C4.41695 22.808 5.86381 21.3612 7.64859 21.3612H54.9725V63.5466H7.64859C5.86381 63.5466 4.41695 62.0997 4.41695 60.3149V24.5928Z"
            stroke="white"
            strokeWidth="2.45524"
        />
        <rect x="55.0841" y="13.4375" width="30.1324" height="60.8229" rx="2.78524" stroke="white" strokeWidth="3.34805" />
        <mask id="path-3-inside-1_137_5339" fill="white">
            <rect x="58.9901" y="22.9236" width="22.3203" height="8.37012" rx="1.39502" />
        </mask>
        <rect
            x="58.9901"
            y="22.9236"
            width="22.3203"
            height="8.37012"
            rx="1.39502"
            stroke="white"
            strokeWidth="5.58008"
            mask="url(#path-3-inside-1_137_5339)"
        />
        <path
            d="M72.9403 59.1941C72.9403 60.735 71.6912 61.9841 70.1503 61.9841C68.6094 61.9841 67.3602 60.735 67.3602 59.1941C67.3602 57.6532 68.6094 56.4041 70.1503 56.4041C71.6912 56.4041 72.9403 57.6532 72.9403 59.1941Z"
            fill="white"
        />
        <rect x="22.7196" y="73.1443" width="19.5303" height="2.79004" rx="1.39502" fill="white" />
        <path
            d="M32.4847 75.9343C33.2552 75.9343 33.8798 75.3098 33.8798 74.5393L33.8798 63.3791C33.8798 62.6087 33.2552 61.9841 32.4847 61.9841C31.7143 61.9841 31.0897 62.6087 31.0897 63.3791L31.0897 74.5393C31.0897 75.3098 31.7143 75.9343 32.4847 75.9343Z"
            fill="white"
        />
    </svg>
);
const ICON_ZA_2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="71" height="96" viewBox="0 0 71 96" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.787 2.38965C44.9684 2.38965 53.2806 6.11116 59.2975 12.128C65.3144 18.1449 69.0359 26.4571 69.0359 35.6385C69.0359 44.82 65.3144 53.1322 59.2975 59.1491C53.2806 65.1659 44.9684 68.8874 35.787 68.8874C26.6055 68.8874 18.2933 65.1659 12.2765 59.1491C6.25959 53.1322 2.53809 44.82 2.53809 35.6385C2.53809 26.4571 6.25959 18.1449 12.2765 12.128C18.2933 6.11116 26.6055 2.38965 35.787 2.38965Z"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.7869 27.2605C38.1003 27.2605 40.1947 28.1982 41.7108 29.7143C43.2268 31.2303 44.1645 33.3247 44.1645 35.6382C44.1645 37.9516 43.2268 40.046 41.7108 41.5621C40.1947 43.0781 38.1003 44.0158 35.7869 44.0158C33.4734 44.0158 31.379 43.0781 29.8629 41.5621C28.3469 40.046 27.4092 37.9516 27.4092 35.6382C27.4092 33.3247 28.3469 31.2303 29.8629 29.7143C31.379 28.1982 33.4734 27.2605 35.7869 27.2605Z"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path
            d="M38.6968 26.0239C41.1598 16.5521 43.7626 11.1966 46.1071 11.8569C49.6237 12.8475 54.9324 16.2253 54.3693 20.6283C53.8927 24.3551 49.4678 29.6502 44.0762 34.1397"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path
            d="M43.2093 40.7083C51.4564 45.9777 55.7455 50.108 54.393 52.1337C52.3642 55.1721 47.5113 59.1771 43.4978 57.2811C40.1006 55.6761 36.432 49.8315 33.8284 43.3165"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path
            d="M26.4304 38.8294C17.3836 42.5626 11.5401 43.707 10.6565 41.4372C9.33127 38.0326 8.83404 31.7601 12.6893 29.56C15.9525 27.6977 22.8444 28.045 29.6745 29.649"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path d="M32.8565 69.7131L30.6877 87.1559" stroke="white" strokeWidth="3.87417" />
        <path d="M43.3013 69.636L46.0245 87.0008" stroke="white" strokeWidth="3.87417" />
        <path
            d="M58.4727 87.6006H16.5843C14.8492 87.6006 13.4427 89.0071 13.4427 90.7422C13.4427 92.4773 14.8492 93.8838 16.5843 93.8838H58.4727C60.2078 93.8838 61.6143 92.4773 61.6143 90.7422C61.6143 89.0071 60.2078 87.6006 58.4727 87.6006Z"
            stroke="white"
            strokeWidth="3.87417"
        />
        <path d="M53.3044 80.7102V86.621" stroke="white" strokeWidth="3.87417" strokeLinecap="round" />
    </svg>
);
const ICON_ZA_3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="77" viewBox="0 0 55 77" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.8446 74.8948H5.89206C4.69201 74.8948 3.60545 74.4602 2.81472 73.7547C2.02027 73.046 1.52722 72.0614 1.52722 70.9731V5.37501C1.52722 4.32187 1.98864 3.36402 2.7403 2.66026C3.53475 1.91638 4.65294 1.45166 5.89206 1.45166H48.8446C50.1619 1.45166 51.3433 1.97656 52.1433 2.80736C52.8076 3.49608 53.2094 4.39208 53.2094 5.37501V70.9731C53.2094 72.1333 52.6476 73.1764 51.7582 73.8935C50.9842 74.5153 49.9646 74.8948 48.8446 74.8948Z"
            stroke="white"
            strokeWidth="2.72012"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.6844 13.0879V18.3546" stroke="white" strokeWidth="2.72012" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.6844 38.5876V47.9503" stroke="white" strokeWidth="2.72012" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.97937 28.8347H53.9153" stroke="white" strokeWidth="2.72012" />
    </svg>
);

export default function J() {
    const { useEffect, useLang, useState, useRouter, useRef } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const [isEnterA, setIsEnterA] = useState(false);
    const videoRefA = useRef();

    let controller: any;

    const videoMap: any = {
        us: ['/video/river2/details/10_us.webm', '/video/river2/details/10_us.mp4'],
        cn: ['/video/river2/details/10_cn.webm', '/video/river2/details/10_cn.mp4'],
        eu: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        ph: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        de: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        fr: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        it: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        es: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        cis: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
        jp: ['/video/river2/details/10_jp.webm', '/video/river2/details/10_jp.mp4'],
        uk: ['/video/river2/details/10_uk.webm', '/video/river2/details/10_uk.mp4'],
        za: ['/video/river2/details/10_za.webm', '/video/river2/details/10_za.mp4'],
        sa: ['/video/river2/details/10_uk.webm', '/video/river2/details/10_uk.mp4'],
        au: ['/video/river2/details/10_au.webm', '/video/river2/details/10_au.mp4'],
        kr: ['/video/river2/details/10_eu.webm', '/video/river2/details/10_eu.mp4'],
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_J .sec2 .imgBox',
            triggerHook: 1,
            offset: 700,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
            if (hasNoneEnterPlayFlag) {
                videoRefA.current?.play();
                hasNoneEnterPlayFlag = false;
            }
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        controller.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const videoDmo = document?.querySelector('#videoJ_A');
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_J .sec2 .imgBox',
            triggerHook: 1,
            offset: 0,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            if (videoDmo) {
                videoDmo.currentTime = 0;
                hasNoneEnterPlayFlag = true;
            }
        });
        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.J_10} river2_detials_J`}>
            <div className={`innerBox${isEnterA ? ' isEnterA' : ''}`}>
                <div className="sec1">
                    <div className="textBox">
                        <p className="guide">{t('river2.details.sec10_1_guide')}</p>
                        <p className="title">{t('river2.details.sec10_1_title')}</p>
                        <p className="desc">
                            {t.rich('river2.details.sec10_1_desc', {
                                h: (h: string) => <span className="h">{h}</span>,
                            })}
                        </p>
                    </div>
                    <div className="imgBox">
                        <div className="imgBox-bg">
                            <EFHandyBg />
                        </div>
                        <div className="imgBox-in">
                            {locale === 'ph' ? (
                                <EFPic2
                                    name="https://websiteoss.ecoflow.com/upload/image/1751079457239/5.jpg"
                                    className="fullImgs"
                                    alt={t('river2.details.sec10_1_title')}
                                    aria-label={t('river2.details.sec10_1_title')}
                                />
                            ) : (
                                <EFPic
                                    name={['10_1.webp', '10_1.png']}
                                    className="fullImgs"
                                    alt={t('river2.details.sec10_1_title')}
                                    aria-label={t('river2.details.sec10_1_title')}
                                />
                            )}
                        </div>
                        <div className="compare-info">
                            <p className="river2">{t('river2.details.sec10_1_river2')}</p>
                            <p className="river2-weight">{t('river2.details.sec10_1_river2_weight')}</p>
                            <div className="icon-box">
                                <EFCompare />
                                <span className="icon-other">{t('river2.details.sec10_1_other')}</span>
                                <span className="icon-river2">{t('river2.details.sec10_1_river2')}</span>
                            </div>
                            <p className="other">{t('river2.details.sec10_1_other_ps')}</p>
                            <p className="other-weight">{t('river2.details.sec10_1_other_weight')}</p>
                        </div>
                    </div>
                </div>
                {/* 增加 us 和 ca 不展示，因为做了优化，不在这个模块展示 */}
                {!['eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph'].includes(locale) && (
                    <div className="sec2">
                        <div className="textBox">
                            <div className="left">{t('river2.details.sec10_2_title')}</div>
                            <div className="right">
                                <p className="red">{t('river2.details.sec10_2_red')}</p>
                                <p className="text">{t('river2.details.sec10_2_desc')}</p>
                            </div>
                        </div>
                        <div className="image-warpper">
                            <div className="imgBox">
                                <div className="imgBox-in1">
                                    <div className="imgBox-in2">
                                        <div className="imgBox-in3">
                                            <EFVideo
                                                sources={videoMap[locale] || videoMap.us}
                                                width="100%"
                                                height="100%"
                                                className="fullImgs"
                                                loop={false}
                                                autoPlay={false}
                                                ref={videoRefA}
                                                id="videoJ_A"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="icon-box">
                                <div className="right-icon-box">
                                    {locale !== 'jp' && (
                                        <div className="icon-box-item">
                                            {locale === 'za' ? (
                                                <>
                                                    <div className="icon">
                                                        <ICON_ZA_1 />
                                                    </div>
                                                    <div className="text-box">
                                                        <p className="time">
                                                            5 <span className="unit">hr</span>
                                                        </p>
                                                        <p className="device">50" TV 100W</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <EFCPAP height="84px" width="84px" />
                                                    <div className="text-box">{t('river2.details.sec10_2_icon1')}</div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                    <div className="icon-box-item">
                                        {locale === 'za' ? (
                                            <>
                                                <div className="icon">
                                                    <ICON_ZA_2 />
                                                </div>
                                                <div className="text-box">
                                                    <p className="time">
                                                        12 <span className="unit">hr</span>
                                                    </p>
                                                    <p className="device">Fan 40W</p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <EFTank height="84px" width="84px" />
                                                <div className="text-box">{t('river2.details.sec10_2_icon2')}</div>
                                            </>
                                        )}
                                    </div>
                                    <div className="icon-box-item">
                                        {locale === 'za' ? (
                                            <>
                                                <div className="icon">
                                                    <ICON_ZA_3 />
                                                </div>
                                                <div className="text-box">
                                                    <p className="time">
                                                        4.5-9 <span className="unit">hr</span>
                                                    </p>
                                                    <p className="device">Refrigerator 120W</p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <EFWifi height="84px" width="84px" />
                                                <div className="text-box">{t('river2.details.sec10_2_icon3')}</div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
